export { default as About } from './About';


// WEBPACK FOOTER //
// ./src/components/About/index.jsx